<template>
  <div v-if="$screen.width <= 992" class="animated fadeIn pr-1 pl-1">
    <div class="container-mobile">
      <div class="my-expense-mobile">
        <div v-if="invoiceItems.length > 0 && !forApprove && !forPending && !forApproved" class="my-expense-status-actions p-1">
          <div class="check-actions cursor-pointer" @click="switchCheckAll">
            <div v-if="checkAll" class="d-flex text-left">
              {{ FormMSG(46, 'None') }}&nbsp;
              <component :is="getLucideIcon('Square')" :size="16" />
            </div>
            <div v-else class="d-flex">
              {{ FormMSG(45, 'All') }}&nbsp;
              <component :is="getLucideIcon('CheckSquare')" :size="16" />
            </div>
          </div>
        </div>
        <div v-if="invoiceItems.length > 0">
          <div v-if="forApprove">
            <div v-for="item in invoiceItems" :key="`A${item.department}`" class="card">
              <div class="wrapper">
                <div class="header">
                  <div class="first-col">
                    <span>{{ item.departmentName }}</span>
                  </div>
                  <div class="second-col d-flex justify-content-end">
                    <div class="status info px-2" style="width: auto">
                      <span>{{ item.invoicesCount }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-for="functionObj in item.expensesByFunction" :key="`B${functionObj.function}`">
                <div v-for="userObj in functionObj.userExpenses" :key="`C${userObj.userId}`">
                  <div v-show="collapsedItems.includes(userObj.userId)" class="card-inside-card">
                    <div class="border border-light rounded-lg">
                      <div class="card mb-3">
                        <div class="wrapper">
                          <div class="header">
                            <div class="first-col details d-flex align-items-center">
                              <div class="full-name">{{ userObj.fullName }}</div>
                              <div>{{ functionObj.functionName.toLowerCase() }}</div>
                            </div>
                            <div class="second-col details d-flex justify-content-end">
                              <div class="status validated px-2" style="width: auto">
                                <span>{{ userObj.expenses.length }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content mx-2">
                        <invoices-data-view-mobile
                          :invoice-items="userObj.expenses"
                          :submitted-state="submittedState"
                          :not-submitted-state="notSubmittedState"
                          :for-approve="forApprove"
                          @show-detail="viewInvoiceDetail"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="footer d-flex flex-row align-items-center">
                    <div v-show="!collapsedItems.includes(userObj.userId)" class="label-footer">
                      <div class="details">
                        <div class="number">{{ userObj.expenses.length }}</div>
                        <div class="full-name">{{ userObj.fullName }}</div>
                        <div class="text-truncate">{{ functionObj.functionName.toLowerCase() }}</div>
                      </div>
                    </div>
                    <div class="actions inline-flex justify-content-end" :style="`width: ${!collapsedItems.includes(userObj.userId) ? '40%' : '100%'}`">
                      <div class="cursor-pointer second-col w-100" @click="toggleCollapse(userObj.userId)">
                        <span class="mr-1">{{
                          !collapsedItems.includes(userObj.userId) ? FormMSG(12345, 'Show details') : FormMSG(67891, 'Hide details')
                        }}</span>
                        <span v-if="!collapsedItems.includes(userObj.userId)">
                          <component :is="getLucideIcon('ChevronDown')" :size="18" />
                        </span>
                        <span v-else>
                          <component :is="getLucideIcon('ChevronUp')" :size="18" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="content pb-3">
              <invoices-data-view-mobile
                :invoice-items="invoiceItems"
                :not-submitted-invoices="notSubmittedInvoices"
                :submitted-state="submittedState"
                :not-submitted-state="notSubmittedState"
                :for-draft="forDraft"
                :for-pending="forPending"
                :for-approved="forApproved"
                :for-multiple-invoice="forMultipleInvoice"
                @select="setSelectedItem"
                @show-detail="viewInvoiceDetail"
              />
            </div>
          </div>
        </div>
        <div v-else class="empty-data pb-3">
          {{ FormMSG(18, 'No invoice found') }}
        </div>
        <b-row v-if="notSubmittedInvoices.length > 0 && !forMultipleInvoice" class="footer-fixed">
          <b-col cols="12">
            <div v-if="forApprove">
              <b-button block size="lg" variant="primary" class="mb-2" @click="handleApproveInvoice">
                <span>{{ FormMSG(38, 'Approve') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
              </b-button>
              <b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleRejectInvoice">
                <span>{{ FormMSG(37, 'Reject') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
              </b-button>
            </div>
            <div v-if="forDraft || forPending">
              <b-button
                v-if="forDraft"
                :disabled="selectedInvoiceMobileHasRefusedItem"
                block
                size="lg"
                variant="primary"
                class="mb-2"
                @click="handleSendInvoiceForApproval"
              >
                <span>
                  {{ FormMSG(39, 'Send for Approval') }}
                  {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}
                </span>
              </b-button>
              <b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleDeleteInvoice">
                <span>{{ FormMSG(35, 'Delete') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="notSubmittedInvoices.length > 0 && forMultipleInvoice">
          <b-col cols="12">
            <b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleDeleteInvoice">
              <span>{{ FormMSG(35, 'Delete') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import globalMixin from '@/mixins/global.mixin';
import invoiceToolsMixin from '@/mixins/invoicesTools.mixin';
import languageMessages from '@/mixins/languageMessages';
import mapProps from '@/shared/vuePropsMapper';
import _ from 'lodash';
import InvoicesDataViewMobile from './InvoicesDataViewMobile.vue';

export default {
  name: 'InvoiceItemMobile',
  components: { InvoicesDataViewMobile },
  mixins: [languageMessages, globalMixin, invoiceToolsMixin],
  props: {
    invoiceItems: {
      type: Array,
      default: () => []
    },
    notSubmittedState: Boolean,
    submittedState: Boolean,
    ...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved', 'forMultipleInvoice'], {
      type: Boolean,
      default: false
    })
  },
  data() {
    return {
      notSubmittedInvoices: [],
      collapsedItems: [],
      checkAll: false
    };
  },
  computed: {
    check() {
      return this.$store.getters.distanceUnit;
    },
    selectedInvoiceMobileHasRefusedItem() {
      return this.notSubmittedInvoices.length > 0 && this.notSubmittedInvoices.some((item) => this.isInvoiceRefused(item));
    }
  },
  methods: {
    toggleCollapse(id) {
      if (this.collapsedItems.includes(id)) {
        this.collapsedItems.splice(this.collapsedItems.indexOf(id), 1);
      } else this.collapsedItems.push(id);
    },
    switchCheckAll() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.notSubmittedInvoices = _.cloneDeep(this.invoiceItems);
      } else {
        this.notSubmittedInvoices = [];
      }
      this.$emit('setSelectedItem', this.notSubmittedInvoices);
    },
    setSelectedItem(event) {
      if (event.length === this.invoiceItems.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.notSubmittedInvoices = _.cloneDeep(event);
      this.$emit('setSelectedItem', event);
    },
    handleApproveInvoice() {
      this.$emit('approveInvoice', this.notSubmittedInvoices);
      this.notSubmittedInvoices = [];
    },
    handleRejectInvoice() {
      this.$emit('rejectInvoice', this.notSubmittedInvoices);
      this.notSubmittedInvoices = [];
    },
    handleSendInvoiceForApproval() {
      this.$emit('sendInvoiceForApproval', this.notSubmittedInvoices);
      this.notSubmittedInvoices = [];
    },
    handleDeleteInvoice() {
      this.$emit('deleteInvoice', this.notSubmittedInvoices);
      this.notSubmittedInvoices = [];
    },
    viewInvoiceDetail(invoice, invoiceIndex) {
      this.$emit('viewInvoiceDetail', invoice, invoiceIndex);
    }
  }
};
</script>
<style lang="scss" scoped>
.container-mobile .card .wrapper .header .first-col {
  &.details {
    width: 90%;
    font-weight: 600;
    font-size: 0.95rem;
    color: rgba(6, 38, 62, 0.74);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.container-mobile .card .wrapper .header .second-col {
  &.details {
    width: 10%;
  }
}
.container-mobile .card .wrapper .header .first-col span {
  font-weight: 600;
  font-size: 1rem;
  color: rgba(6, 38, 62, 0.74);
}

.container-mobile .card .wrapper .header .second-col .status span {
  font-size: 0.85rem;
}
.label-footer {
  padding: 0 0 0 12px;
  width: 60%;
  color: rgba(6, 38, 62, 0.74);
  font-weight: 500;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow-x: clip;
  text-overflow: ellipsis;
  .details {
    display: inline-flex;
    width: 100%;
  }
}

.full-name:after,
.number:after {
  content: '\A';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3c7442;
  display: inline-block;
  margin: 0 8px;
}
</style>
